import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';
import Button from '../../common/Button';

const SolutionsCallToAction = () => {
  return (
    <section className="py-16 bg-gray-50">
      <Container>
        <div className="bg-white p-8 md:p-12 rounded-xl shadow-lg border border-gray-100">
          <div className="max-w-3xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold mb-6 text-gray-900">
                Ready to Transform Your IT Infrastructure?
              </h2>
              
              <p className="text-gray-600 mb-8">
                Contact our team today to discuss your specific requirements and discover how our 
                IT solutions can help drive your business forward.
              </p>
              
              <div className="flex flex-wrap justify-center gap-4">
                <Button 
                  to="/contact" 
                  variant="primary"
                  size="lg"
                >
                  Get in Touch
                </Button>
                
                <Button 
                  to="/services" 
                  variant="outline"
                  size="lg"
                >
                  Explore Our Services
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default SolutionsCallToAction;